module.exports = __webpack_public_path__ + "img/no-task.bb8be33c.png";